/* eslint-disable eqeqeq */
import React from 'react';
import { connect } from 'react-redux';

import { Form, Input, Loader, Select } from 'semantic-ui-react';

import { loadPlaceLKPS } from './../../reduxFiles/placeLKPSActions';

class PlaceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredMunicipalities: [],
            disableMunicipality: false,
            edit: false,
        };
        this.onPlaceChange = this.onPlaceChange.bind(this);
    }

    componentDidMount() {
        if (!this.props.placeLKPS.loaded && !this.props.placeLKPS.loading) {
            this.props.loadPlaceLKPS();
        }
    }

    onPlaceChange(event, { name, value }) {
        this.setState({ edit: true });
        const {
            entities, municipalities, cantons, defaults
        } = this.props.placeLKPS;
        let valuesCopy = { ...this.props.values };
        // TODO: refactor,  repetitive cases
        switch (name) {
        case 'country':
        {
            valuesCopy.country = value;
            if (value == defaults.bihId) {
                valuesCopy.entity = entities[0].value;
                if (valuesCopy.entity == defaults.fbihId) {
                    // set first canton
                    valuesCopy.canton = cantons[8].value;
                    // update municipality dropwdown for this canton
                    const filteredMunicipalities = municipalities.filter(el => el.canton == cantons[8].value);
                    this.setState({ filteredMunicipalities });
                    // set first municipality
                    valuesCopy.municipality = filteredMunicipalities[0].value;
                } else {
                    // deselect cantons
                    valuesCopy.cantons = null;
                    const filteredMunicipalities = municipalities.filter(el => el.entity == valuesCopy.entity);
                    this.setState({ filteredMunicipalities });
                    // set first municipality
                    valuesCopy.municipality = filteredMunicipalities[0].value;
                }
            } else {
                // country is not BiH, deselct other dropwdowns
                valuesCopy.entity = null;
                valuesCopy.canton = null;
                this.setState({ filteredMunicipalities: [] });
                valuesCopy.municipality = null;
            }
            break;
        }
        case 'entity':
        {
            valuesCopy.entity = value;
            if (valuesCopy.entity == defaults.fbihId) {
                // set first canton
                valuesCopy.canton = cantons[8].value;
                // update municipality dropwdown for this canton
                const filteredMunicipalities = municipalities.filter(el => el.canton == cantons[8].value);
                this.setState({ filteredMunicipalities });
                // set first municipality
                this.setState({ disableMunicipality: false });
                valuesCopy.municipality = filteredMunicipalities[0].value;
            } else {
                // deselect cantons
                valuesCopy.cantons = null;
                const filteredMunicipalities = municipalities.filter(el => el.entity == valuesCopy.entity);
                this.setState({ filteredMunicipalities });

                // set first municipality
                filteredMunicipalities.length ? valuesCopy.municipality = filteredMunicipalities[0].value : this.setState({ disableMunicipality: true });
            }
            break;
        }
        case 'canton':
        {
            valuesCopy.canton = value;
            const filteredMunicipalities = municipalities.filter(el => el.canton == value);
            this.setState({ filteredMunicipalities });
            valuesCopy.municipality = filteredMunicipalities[0].value;
            break;
        }
        case 'municipality':
        {
            valuesCopy.municipality = value;
            break;
        }
        case 'place': {
            valuesCopy.place = value;
            break;
        }
        case 'address': {
            valuesCopy.address = value;
            break;
        }
        default:
        }
        this.props.onPlaceChange(valuesCopy, this.props.formName);
    }
    render() {
        if (this.props.placeLKPS.error) return <div>ERROR </div>;
        if (!this.props.placeLKPS.loaded) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const {
            countries,
            entities,
            cantons,
            defaults
        } = this.props.placeLKPS;
        const { filteredMunicipalities } = this.state;
        return (
            <Form >
                <Form.Field
                    disabled={localStorage.getItem('associate') === 'true' && this.props.currentResidence}
                    required={this.props.formName !== 'placeOfCurrentResidence'}
                    control={Select}
                    clearable
                    options={countries}
                    placeholder="Država"
                    label="Država"
                    onChange={this.onPlaceChange}
                    name="country"
                    value={this.props.values.country}
                    search
                    multiple={this.props.multiple}
                    deburr
                    error={this.props.countryErr}
                />


                <Form.Field
                    required={this.props.formName !== 'placeOfCurrentResidence'}
                    control={Select}
                    clearable
                    options={entities}
                    placeholder="Entitet"
                    label="Entitet"
                    onChange={this.onPlaceChange}
                    name="entity"
                    selectOnNavigation={false}
                    openOnFocus={false}
                    value={this.props.values.entity}
                    disabled={defaults.bihId != this.props.values.country || (localStorage.getItem('associate') === 'true' && this.props.currentResidence)}
                    search
                    error={this.props.entityErr}
                />
                <Form.Field
                    required={this.props.formName !== 'placeOfCurrentResidence'}
                    control={Select}
                    options={cantons}
                    placeholder="Kanton"
                    label="Kanton"
                    onChange={this.onPlaceChange}
                    name="canton"
                    search
                    openOnFocus={false}
                    value={this.props.values.canton}
                    error={this.props.cantonError}
                    disabled={(defaults.bihId != this.props.values.country)
                    || (defaults.fbihId != this.props.values.entity) || (localStorage.getItem('associate') === 'true' && this.props.currentResidence)
                    }
                />
                <Form.Field
                    required={this.props.formName !== 'placeOfCurrentResidence'}
                    control={Select}
                    clearable
                    options={filteredMunicipalities.length ? filteredMunicipalities : this.props.municipalitiesStart}
                    placeholder="Općina"
                    label="Općina"
                    onChange={this.onPlaceChange}
                    name="municipality"
                    search
                    openOnFocus={false}
                    value={this.props.values.municipality}
                    disabled={(defaults.bihId !== this.props.values.country)
                        // || (this.props.bdId === this.props.values.entity)
                    || (localStorage.getItem('associate') === 'true' && this.props.currentResidence)}
                    error={this.props.municipalityError}
                />
                <Form.Field
                    disabled={localStorage.getItem('associate') === 'true' && this.props.currentResidence}
                    required={this.props.formName !== 'placeOfCurrentResidence'}
                    control={Input}
                    placeholder="Mjesto"
                    label="Mjesto"
                    value={this.props.values.place}
                    onChange={this.onPlaceChange}
                    error={this.props.placeErr}
                    name="place"
                />
                {!this.props.noAdress && <Form.Field
                    disabled={localStorage.getItem('associate') === 'true' && this.props.currentResidence}
                    required={this.props.formName !== 'placeOfCurrentResidence'}
                    control={Input}
                    placeholder="Adresa"
                    label="Adresa"
                    value={this.props.values.address}
                    onChange={this.onPlaceChange}
                    error={this.props.addressErr}
                    name="address"
                />}
            </Form>
        );
    }
}

const mapStateToProps = ({ placeLKPS }) => ({ placeLKPS });
export default connect(mapStateToProps, { loadPlaceLKPS })(PlaceForm);



// WEBPACK FOOTER //
// ./src/views/util/PlaceForm.js